import React, { Component, Fragment } from "react";
import Loader from "../../loader";
import ErrorComponent from "../../errorComponent";
import CardQueue from "./cardQueue";

class CardRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      error: false
    };
  }

  componentDidMount() {
    const url = "https://content.uvm.edu/shared/api/v1.0/card-queues/" + this.props.cardQueue + "?include=cards";
    fetch(url)
      .then(this.handleErrors) // handles response errors like 404
      .then(response => response.json())
      .then(data =>
        this.setState({
          loading: false,
          data: data,
        })
      )
      .catch(error => this.setState({ loading: false, error })); // Handles request errors like CORS
  }

  handleErrors(response) {
    // Check for !200 response
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  }

  render() {
    const { loading, data, error } = this.state;
    return loading ? (
      <Loader />
    ) : error ? (
      <ErrorComponent error={error} />
    ) : data.included !== undefined ? ( // Trap for null data
      <CardQueue queue={data.included} />
    ) : (
      <p>Empty card queue.</p>
    );
  }
}

export default CardRow;